(function ($) {
	class W4D_Countdown {
		constructor(element) {
			this.container = $(element);
			this.timerInterval = null;
			this.initTimer();
		}

		initTimer() {
			this.isFlip = this.container.hasClass('countdown--flip');
			const dayValue = this.container.find('[data-js="d"]');
			const hourValue = this.container.find('[data-js="h"]');
			const minuteValue = this.container.find('[data-js="m"]');
			const secondValue = this.container.find('[data-js="s"]');

			if (!dayValue.length || !hourValue.length || !minuteValue.length || !secondValue.length) return;

			const timerElement = this.container.find('.countdown__timer');

			const dayLabel = dayValue.siblings('.countdown__label');
			const hourLabel = hourValue.siblings('.countdown__label');
			const minuteLabel = minuteValue.siblings('.countdown__label');
			const secondLabel = secondValue.siblings('.countdown__label');

			const isShortLabel = dayLabel.text().length <= 2;

			let days = parseInt(dayValue.text(), 10) || 0;
			let hours = parseInt(hourValue.text(), 10) || 0;
			let minutes = parseInt(minuteValue.text(), 10) || 0;
			let seconds = parseInt(secondValue.text(), 10) || 0;

			if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) return;

			const pad = (num) => String(num).padStart(2, '0');

			let totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;

			const tick = () => {
				if (totalSeconds <= 0) {
					clearInterval(this.timerInterval);
					this.timerInterval = null;
					return;
				}

				totalSeconds--;

				days = Math.floor(totalSeconds / 86400);
				hours = Math.floor((totalSeconds % 86400) / 3600);
				minutes = Math.floor((totalSeconds % 3600) / 60);
				seconds = totalSeconds % 60;

				const updateValue = (el, val) => {
					const padded = pad(val);
					if (this.isFlip) {
						const html = `<span>${padded[0]}</span><span>${padded[1]}</span>`;
						if (el.html() !== html) {
							el.html(html);
						}
					} else {
						if (el.text() !== padded) {
							el.text(padded);
						}
					}
				};

				updateValue(dayValue, days);
				updateValue(hourValue, hours);
				updateValue(minuteValue, minutes);
				updateValue(secondValue, seconds);

				if (dayLabel.length) dayLabel.text(this.formatTimeLabel(days, 'd', isShortLabel));
				if (hourLabel.length) hourLabel.text(this.formatTimeLabel(hours, 'h', isShortLabel));
				if (minuteLabel.length) minuteLabel.text(this.formatTimeLabel(minutes, 'm', isShortLabel));
				if (secondLabel.length) secondLabel.text(this.formatTimeLabel(seconds, 's', isShortLabel));

				if (timerElement.length) {
					timerElement.attr('datetime', `P${days}DT${hours}H${minutes}M${seconds}S`);
				}
			};

			// Initial label update
			if (dayLabel.length) dayLabel.text(this.formatTimeLabel(days, 'd', isShortLabel));
			if (hourLabel.length) hourLabel.text(this.formatTimeLabel(hours, 'h', isShortLabel));
			if (minuteLabel.length) minuteLabel.text(this.formatTimeLabel(minutes, 'm', isShortLabel));
			if (secondLabel.length) secondLabel.text(this.formatTimeLabel(seconds, 's', isShortLabel));

			this.timerInterval = setInterval(tick, 1000);
		}

		formatTimeLabel(value, type, isShortLabel = false) {
			if (isShortLabel) {
				return type;
			}

			const lastDigit = value % 10;
			const lastTwoDigits = value % 100;

			const labels = {
				d: {
					one: 'Dan',
					few: 'Dana',
					many: 'Dana',
				},
				h: {
					one: 'Sat',
					few: 'Sata',
					many: 'Sati',
				},
				m: {
					one: 'Minuta',
					few: 'Minute',
					many: 'Minuta',
				},
				s: {
					one: 'Sekunda',
					few: 'Sekunde',
					many: 'Sekundi',
				},
			};

			const labelSet = labels[type];

			if (value === 1 || (lastDigit === 1 && lastTwoDigits !== 11)) {
				return labelSet.one;
			}

			if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
				return labelSet.few;
			}

			return labelSet.many;
		}
	}

	window.W4D_Countdown = W4D_Countdown;

	$(document).ready(() => {
		$('.countdown').each(function () {
			new W4D_Countdown(this);
		});
	});
})(jQuery);
